import React, { Component } from 'react';
import { connect } from 'react-redux';

import
  InviteConfirmationComponent
from '../../components/invite-people/invite-confirmation';

import {
  hideInviteConfirmationModal,
  showInviteModal,
} from '../../actions/index';

class InviteConfirmation extends Component {
  sendMoreInvites() {
    this.props.hideInviteConfirmationModal();
    this.props.showInviteModal();
  }

  render() {
    return (
      <InviteConfirmationComponent
        showInvitePeopleModal={() => this.sendMoreInvites()}
        closeModal={this.props.hideInviteConfirmationModal}
      />
    );
  }
}

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  hideInviteConfirmationModal,
  showInviteModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(InviteConfirmation);




// WEBPACK FOOTER //
// ./src/desktop/containers/invite-people/invite-confirmation.container.js